import { GameClock } from './timing';
import { isModActive } from './mods.js';

const SPIN_BONUS_HEAL = 0.01;

export default class HealthTracker {
  hp: number;
  drainRate: number; // fraction per second
  private lastUpdate: number;

  constructor(startHp = 1, hpDifficulty = 5) {
    this.hp = startHp;
    // Scale base drain rate by HP difficulty (higher HP -> faster drain)
    this.drainRate = 0.02 * (hpDifficulty / 5);
    this.lastUpdate = GameClock.now();
  }

  /** Apply passive health drain based on elapsed time. */
  tick(now = GameClock.now()): void {
    const dt = (now - this.lastUpdate) / 1000;
    this.lastUpdate = now;
    const floor = isModActive('noFail') ? 0.1 : 0;
    this.hp = Math.max(floor, this.hp - this.drainRate * dt);
  }

  /** Adjust health based on judgement result. */
  apply(result: string, progress = 0): void {
    if (result === 'spinner') {
      const gain = 0.05 * Math.min(Math.max(progress, 0), 1);
      const floor = isModActive('noFail') ? 0.1 : 0;
      this.hp = Math.max(floor, Math.min(1, this.hp + gain));
      return;
    }
    if (result === 'spinBonus') {
      const floor = isModActive('noFail') ? 0.1 : 0;
      this.hp = Math.max(floor, Math.min(1, this.hp + SPIN_BONUS_HEAL));
      return;
    }
    const changes: Record<string, number> = {
      perfect: 0.05,
      great: 0.03,
      good: 0.01,
      tick: 0.01,
      repeat: 0.02,
      end: 0.03,
      miss: -0.1,
    };
    const delta = changes[result] ?? 0;
    const floor = isModActive('noFail') ? 0.1 : 0;
    this.hp = Math.max(floor, Math.min(1, this.hp + delta));
  }
}
